import { ProductTypeEN, RequestCategory } from 'cpfr-common';

export const categoriesPerProduct: { [key: string]: RequestCategory[] } = {
    [ProductTypeEN.CREDIT]: [
        'VEHICLE_CLAIM',
        'DEADLINE',
        'AUTHORIZATION_DEBIT',
        'LOSS',
        'CHANGE_DURATION_MILEAGE',
        'DEATH',
        'DOCUMENTS',
        'OTHER',
    ],
    [ProductTypeEN.BALLON_LEASING]: [
        'VEHICLE_CLAIM',
        'DEADLINE',
        'AUTHORIZATION_DEBIT',
        'LOSS',
        'CHANGE_DURATION_MILEAGE',
        'DEATH',
        'REQUEST_CONTRACT_TRANSFER',
        'DOCUMENTS',
        'OTHER',
    ],
    [ProductTypeEN.OPERATIVE_LEASING]: [
        'VEHICLE_CLAIM',
        'LOSS',
        'CHANGE_DURATION_MILEAGE',
        'DEATH',
        'DOCUMENTS',
        'TENANT',
        'OTHER',
    ],
    [ProductTypeEN.FINANCIAL_LEASE]: [
        'VEHICLE_CLAIM',
        'AUTHORIZATION_DEBIT',
        'LOSS',
        'CHANGE_DURATION_MILEAGE',
        'DEATH',
        'DOCUMENTS',
        'TENANT',
        'OTHER',
    ],
    [ProductTypeEN.VDL]: ['DOCUMENTS', 'OTHER'],
    [ProductTypeEN.STAND_ALONE]: ['DOCUMENTS', 'OTHER'],
    [ProductTypeEN.OTHER]: ['OTHER'],
};
